const setTypeOrder$ = 'order/setTypeOrder$';
const SET_TYPE = 'order/SET_TYPE';
const SET_RECURRING = 'order/SET_RECURRING';
const disableEconomyMode$ = 'order/disableEconomyMode$';
const enableEconomyMode$ = 'order/enableEconomyMode$';

const SET_MAX_ITEMS_IN_LOAD = 'order/SET_MAX_ITEMS_IN_LOAD';
const SET_MAX_REACHED = 'order/SET_MAX_REACHED';
const SET_QUOTE_SUGGESTIONS = 'order/SET_QUOTE_SUGGESTIONS';
const CLEAN_QUOTE_SUGGESTIONS = 'order/CLEAN_QUOTE_SUGGESTIONS';
const SET_SHIPPER_QUOTE_ID = 'order/SET_SHIPPER_QUOTE_ID';

const fetchQuote$ = 'order/fetchQuote$';
const submitQuote$ = 'order/submitQuote$';
const confirmOrder$ = 'order/confirmOrder$';
const payOrder$ = 'order/payOrder$';
const submitOrder$ = 'order/submitOrder$';
const submitEditOrder$ = 'order/submitEditOrder$';
const submitNonCoreOrder$ = 'order/submitNonCoreOrder$';
const discardEdition$ = 'order/discardEdition$';

const SET_MAXIMUMS = 'order/SET_MAXIMUMS';
const SET_HOLIDAYS = 'order/SET_HOLIDAYS';
const SET_VALIDATIONS = 'order/SET_VALIDATIONS';

const setExtra$ = 'order/setExtra$';

const setAditionalOption$ = 'order/setAditionalOption$';
const checkAditionalOption$ = 'order/checkAditionalOption$';

const setDefaults$ = 'order/setDefaults$';

const navigateToForm$ = 'order/navigateToForm$';
const discardOrder$ = 'order/discardOrder$';

const repeatOrder$ = 'order/repeatOrder$';
const prefillSuggestedOrder$ = 'order/prefillSuggestedOrder$';

const setRange$ = 'order/setRange$';
const setDay$ = 'order/setDay$';

const fetchHolidays$ = 'order/fetchHolidays$';

const startOrderWithAddress$ = 'order/startOrderWithAddress$';

const checkPaymentMethod$ = 'order/checkPaymentMethod$';

const SET_PAYMENT_INTENT_SECRET = 'order/SET_PAYMENT_INTENT_SECRET';
const SET_LAST_ID = 'order/SET_LAST_ID';

const SET_EDITING = 'order/SET_EDITING';
const editOrder$ = 'order/editOrder$';

const cleanRepeatAndEditing$ = 'order/cleanRepeatAndEditing$';

const applyHolidays$ = 'order/applyHolidays$';
const getValidations$ = 'order/getValidations$';
const watchForShipperQuoteId$ = 'order/watchForShipperQuoteId$';
const fetchTimeWindows$ = 'order/fetchTimeWindows$';
const SET_TIME_WINDOWS = 'order/SET_TIME_WINDOWS';
const CLEAN_TIME_WINDOWS = 'order/CLEAN_TIME_WINDOWS';
const SET_TIME_WINDOWS_REQUEST_PAYLOAD =
  'order/SET_TIME_WINDOWS_REQUEST_PAYLOAD';

export default {
  setTypeOrder$,
  SET_TYPE,
  SET_RECURRING,
  disableEconomyMode$,
  enableEconomyMode$,
  SET_QUOTE_SUGGESTIONS,
  CLEAN_QUOTE_SUGGESTIONS,
  SET_SHIPPER_QUOTE_ID,

  SET_MAX_ITEMS_IN_LOAD,
  SET_MAX_REACHED,
  SET_MAXIMUMS,
  SET_HOLIDAYS,
  SET_VALIDATIONS,
  fetchQuote$,
  submitQuote$,
  confirmOrder$,
  payOrder$,
  submitOrder$,
  submitEditOrder$,
  submitNonCoreOrder$,
  discardEdition$,
  setExtra$,
  setAditionalOption$,
  checkAditionalOption$,
  setDefaults$,
  navigateToForm$,
  discardOrder$,
  repeatOrder$,
  prefillSuggestedOrder$,

  setRange$,
  setDay$,
  fetchHolidays$,
  startOrderWithAddress$,

  checkPaymentMethod$,

  SET_PAYMENT_INTENT_SECRET,
  SET_LAST_ID,

  editOrder$,
  SET_EDITING,

  cleanRepeatAndEditing$,
  applyHolidays$,
  getValidations$,

  watchForShipperQuoteId$,
  fetchTimeWindows$,
  SET_TIME_WINDOWS,
  CLEAN_TIME_WINDOWS,
  SET_TIME_WINDOWS_REQUEST_PAYLOAD,
};
